import React from 'react';
import { FaBolt } from 'react-icons/fa';
import { useDisclosure } from '@chakra-ui/react';
import { useAuthenticatedUserInfo } from '../../services/Contexts/AuthenticatedUserInfoContext';
import { useEmailUsage } from '../../hooks/useSendGridSubuser';
import { useSyncEmailPackLimits } from '../../hooks/useEmailPacks';
import EmailPackPurchaseModal from '../EmailPacks/EmailPackPurchaseModal';
import HeaderToolbarIconButton, {
	HeaderToolbarBadge,
} from '../layout/HeaderToolbarIconButton';

const EmailPackHeaderAction = ({ size = 'sm' }) => {
	const { companyId } = useAuthenticatedUserInfo();
	const { data: emailUsage, isLoading, refetch } = useEmailUsage(companyId);
	const { mutate: syncPackLimits } = useSyncEmailPackLimits(companyId);
	const { isOpen, onOpen, onClose } = useDisclosure();

	const emailsSent = emailUsage?.stats?.emailsSentThisMonth ?? 0;
	const effectiveLimit = emailUsage?.stats?.monthlyEmailLimit ?? null;
	const enforcementActive =
		emailUsage?.stats?.subscriptionInfo?.enforcementActive !== false;

	const isLimitReached =
		!isLoading &&
		enforcementActive &&
		effectiveLimit !== null &&
		effectiveLimit !== undefined &&
		emailsSent >= effectiveLimit;

	if (!isLimitReached) {
		return null;
	}

	const label = `Monthly send limit reached (${emailsSent.toLocaleString()} / ${effectiveLimit.toLocaleString()}) — Buy packs & add-ons`;

	const handlePurchaseSuccess = () => {
		syncPackLimits(undefined, { onSuccess: () => refetch() });
	};

	return (
		<>
			<HeaderToolbarIconButton
				aria-label={label}
				title={label}
				icon={<FaBolt />}
				size={size}
				tone='alert'
				onClick={onOpen}
				badge={<HeaderToolbarBadge>!</HeaderToolbarBadge>}
			/>

			<EmailPackPurchaseModal
				isOpen={isOpen}
				onClose={onClose}
				onPurchaseSuccess={handlePurchaseSuccess}
				title='Buy Packs & Add-ons'
				description='Your monthly send limit is reached. Add a one-time top-up or monthly send pack to continue sending campaigns.'
			/>
		</>
	);
};

export default EmailPackHeaderAction;
